// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-header[data-v-d0e04ef4]{background-color:#bcbfcc!important;border-radius:5px;color:#fff}.sub-header .bold-text[data-v-d0e04ef4]{font-size:inherit;font-weight:700}.notice-bar[data-v-d0e04ef4]{font-weight:700;color:red}", ""]);
// Exports
module.exports = exports;
